import htmx from "htmx.org"
import registry from "@patternslib/patternslib/src/core/registry"

window.reloadAfterSuccess = (pattern, response, state, xhr, form) => {
    // grab action element
    const el = pattern.$el[0]

    const event = el.getAttribute('data-reload')
    if (event){
        document.body.dispatchEvent(new Event(event));
    }
}

document.addEventListener("DOMContentLoaded", function() {

    // reinitialize patterns loaded via htmx
    document.body.addEventListener('htmx:afterSwap', function(evt) {
        registry.scan(evt.target);
    });

})